/**
 * Баннер разработчика о срезе портов: нужен ли он и что в нём сказать.
 *
 * Показывается, когда срез устарел, последняя автозагрузка не удалась
 * или папка автозагрузки недоступна. Сведения — от сервера
 * (GET /api/ports/import-status).
 */
import { plural } from './plural';

const pad = (n) => String(n).padStart(2, '0');

/** «2026-11-02» → «02.11.2026» */
export const formatSnapshotDate = (iso) => {
  const m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : '';
};

/** Время события коротко: «03.11 06:30» */
export const formatShortTime = (ms) => {
  const d = new Date(Number(ms));
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/**
 * Что показать. null — показывать нечего.
 * { tone: 'warn' | 'error', title, details: [строки], key } — key меняется
 * вместе с положением дел: закрытый баннер вернётся, если станет хуже.
 */
export function portsSliceBanner(status) {
  if (!status) return null;
  const { inbox = {}, lastRun, lastOk, stale, ageDays, latestSnapshot } = status;

  const failedRun =
    lastRun && lastRun.status === 'error' && (!lastOk || lastRun.id > lastOk.id) ? lastRun : null;
  const folderProblem = inbox.enabled && inbox.problem ? inbox.problem : null;
  if (!stale && !failedRun && !folderProblem) return null;

  let title;
  if (stale) {
    title = latestSnapshot
      ? `Срез портов не обновлялся ${ageDays} ${plural(ageDays, 'день', 'дня', 'дней')} — данные от ${formatSnapshotDate(latestSnapshot)}`
      : 'Срез портов ещё не загружен';
  } else if (failedRun) {
    title = 'Автозагрузка среза портов не удалась';
  } else {
    title = 'Папка автозагрузки среза недоступна';
  }

  const details = [];
  if (!inbox.enabled) {
    details.push(
      'Автозагрузка не настроена (PORTS_INBOX_DIR) — срез загружают вручную в разделе «Порты».'
    );
  }
  if (folderProblem) details.push(`Папка: ${folderProblem}.`);
  if (failedRun) {
    const when = formatShortTime(failedRun.finished_at || failedRun.started_at);
    const file = failedRun.file_name ? `«${failedRun.file_name}»` : 'файл';
    details.push(`${when}, ${file}: ${failedRun.error || 'ошибка без описания'}.`);
  }
  if (inbox.enabled && !folderProblem && !failedRun && stale) {
    if (!inbox.newest) details.push('В папке нет файлов .xlsx или .csv.');
    else if (lastOk && inbox.newest.name === lastOk.file_name) {
      details.push(
        `Новых файлов нет: самый свежий в папке — «${inbox.newest.name}», он уже загружен.`
      );
    } else details.push(`Самый свежий файл в папке — «${inbox.newest.name}».`);
  }
  if (inbox.enabled && inbox.checkedAt) {
    details.push(
      `Папка проверена ${formatShortTime(inbox.checkedAt)}, проверка каждые ${inbox.intervalMin} мин.`
    );
  }

  return {
    tone: failedRun || folderProblem ? 'error' : 'warn',
    title,
    details,
    key: [latestSnapshot, failedRun ? failedRun.id : '', folderProblem || ''].join('|'),
  };
}
